import CustomMultiReactSelect from "./custom-multi-react-select.component";

export default CustomMultiReactSelect;
